import get from "lodash/get"
import {
  GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_PENDING,
  GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_FULFILLED,
  GET_MY_WM_BROKER_PAYMENT_CAPTURE_FULFILLED,
  GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_FAILED,
  CREATE_SCHEDULE_PAYMENT_PENDING,
  CREATE_SCHEDULE_PAYMENT_FULFILLED,
  CREATE_SCHEDULE_PAYMENT_FAILED,
  DELETE_SCHEDULED_PAYMENT_PENDING,
  CLEAR_DELETE_SCHEDULED_PAYMENT_STATUS,
  DELETE_SCHEDULED_PAYMENT_FULFILLED,
  DELETE_SCHEDULED_PAYMENT_FAILED,
  CLEAR_CREATE_SCHEDULED_PAYMENT_STATUS,
  GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_DUPLICATE,
  GET_MY_WM_PAYMENT_SERVICES_PENDING,
  GET_MY_WM_PAYMENT_SIGNATURE_PENDING,
  GET_MY_WM_PAYMENT_VERIFICATION_PENDING,
  GET_MY_WM_PAYMENT_CANCEL_TRANSACTION,
  RESET_MY_WM_PAYMENT_INFO,
  RESET_DASHBOARD_FROM_GETTING_STARTED,
  GET_USER_PAYMENT_METHODS_PENDING,
  SET_USER_STATE,
} from "constants-lib/actionTypes"
import { userType } from "constants-lib/authentication"

const initialState = {
  /* Payment capture */
  postStatus: ``,
  saleResponseErrorMessage: ``,
  isApplePayAutoPayEnrolled: false,
  isApplePayConfirm: false,
  isApplePayScheduled: false,
  isDuplicatePayment: false,
  paymentMethod: ``,
  paymentStatus: ``,
  confirmationNumber: ``,
  lastPaymentAmount: `0.00`,
  /* Schedule payment capture */
  createScheduledPaymentStatus: ``,
  scheduledState: ``,
  scheduledConfirmationNumber: ``,
  deleteScheduledPaymentStatus: ``,
  declineDescription: ``,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    /* Payment capture */
    case GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_PENDING:
      return {
        ...state,
        postStatus: `pending`,
        myPaymentConfirm: {},
      }

    case GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_FULFILLED:
    case GET_MY_WM_BROKER_PAYMENT_CAPTURE_FULFILLED:
      return {
        ...state,
        ...action.payload,
        postStatus: `fulfilled`,
      }
    case GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_FAILED:
      return {
        ...state,
        saleResponseErrorMessage: action.payload.errorMessage,
        postStatus: `failed`,
      }
    /* Schedule Payment Capture */
    case CREATE_SCHEDULE_PAYMENT_PENDING:
      return {
        ...state,
        createScheduledPaymentStatus: `pending`,
      }
    case CREATE_SCHEDULE_PAYMENT_FULFILLED:
      return {
        scheduledConfirmationNumber: get(
          action.payload,
          `scheduledConfirmationNumber`,
          ``,
        ),
        createScheduledPaymentStatus: `fulfilled`,
        scheduledState: `SCHEDULED`,
      }
    case CREATE_SCHEDULE_PAYMENT_FAILED:
      return {
        ...state,
        saleResponseErrorMessage: action.payload.errorMessage,
        createScheduledPaymentStatus: `failed`,
      }

    case DELETE_SCHEDULED_PAYMENT_PENDING:
      return {
        ...state,
        deleteScheduledPaymentStatus: `pending`,
      }
    case CLEAR_DELETE_SCHEDULED_PAYMENT_STATUS:
      return {
        ...state,
        deleteScheduledPaymentStatus: ``,
      }
    case DELETE_SCHEDULED_PAYMENT_FULFILLED:
      return {
        scheduledConfirmationNumber: get(
          action.payload,
          `data.data.confirmationNumber`,
          ``,
        ),
        createScheduledPaymentStatus: ``,
        deleteScheduledPaymentStatus: `fulfilled`,
        scheduledState: `DELETED`,
      }
    case DELETE_SCHEDULED_PAYMENT_FAILED:
      return {
        ...state,
        saleResponseErrorMessage: action.payload.errorMessage,
        deleteScheduledPaymentStatus: `failed`,
      }
    case CLEAR_CREATE_SCHEDULED_PAYMENT_STATUS:
      return {
        ...state,
        createScheduledPaymentStatus: ``,
        postStatus: ``,
      }

    /* Payment duplicate */
    case GET_MY_WM_PAYMENT_PAYMENT_CAPTURE_DUPLICATE:
      return {
        ...state,
        isDuplicatePayment: action.payload,
      }

    /* Initialize state */
    case GET_MY_WM_PAYMENT_SERVICES_PENDING:
    case GET_MY_WM_PAYMENT_SIGNATURE_PENDING:
    case GET_MY_WM_PAYMENT_VERIFICATION_PENDING:
    case GET_MY_WM_PAYMENT_CANCEL_TRANSACTION:
    case RESET_MY_WM_PAYMENT_INFO:
    case RESET_DASHBOARD_FROM_GETTING_STARTED:
    case GET_USER_PAYMENT_METHODS_PENDING:
      return initialState

    case SET_USER_STATE: {
      /* Clear state after logging in. */
      if (action.payload === userType.LOGGED_IN) {
        return {
          ...initialState,
        }
      }
      return {
        ...state,
      }
    }

    default:
      return state
  }
}
